import React from 'react';
import styles from './StatusChevronFilter.module.scss';
import { MobileStatusChevron } from '@/helpers/requestStatus';

interface StatusChevronFilterProps {
  items: MobileStatusChevron[];
  /** Per-chevron selected flag (same multi-select semantics as desktop pills). */
  isSelected: (item: MobileStatusChevron) => boolean;
  onToggle: (item: MobileStatusChevron) => void;
}

/**
 * SPR-1205 — mobile status filter as a dense RTL chevron bar (Figma 186:68).
 * Hug-width segments, horizontal scroll, active rests on the right.
 * Labels are exact Figma copy — never truncated or suffixed.
 */
const StatusChevronFilter: React.FC<StatusChevronFilterProps> = ({ items, isSelected, onToggle }) => {
  return (
    <div className={styles.scroll} role="toolbar" aria-label="סינון לפי סטטוס" data-status-chevron>
      <div className={styles.bar}>
        {items.map((item, index) => {
          const selected = isSelected(item);
          const isFirst = index === 0;
          const isLast = index === items.length - 1;

          return (
            <button
              key={item.id}
              type="button"
              className={[
                styles.segment,
                selected ? styles.segmentActive : '',
                isFirst ? styles.segmentFirst : '',
                isLast ? styles.segmentLast : '',
              ]
                .filter(Boolean)
                .join(' ')}
              aria-pressed={selected}
              onClick={() => onToggle(item)}
            >
              <span className={styles.label}>{item.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default StatusChevronFilter;
